import { createTheme } from '@material-ui/core/styles';

const defaultTheme = createTheme();
const theme = createTheme({
  palette: {
    primary: { main: '#0061FF' },
    secondary: { main: '#D2363F' },
  },
  typography: {
    fontFamily: 'SF Pro Text Regular',
    fontSize: 16,
    h1: {
      color: '#383840',
    },
    h2: {
      color: '#383840',
    },
    body1: {
      color: '#383840',
    },
    subtitle1: {
      fontSize: '.875rem',
    },
    subtitle2: {
      fontSize: '.75rem',
    },
  },
  overrides: {
    MuiButton: {
      root: {
        display: 'flex',
        alignItems: 'center',
        height: 40,
        textTransform: 'initial',
        fontWeight: 700,
        borderRadius: 20,
      },
      sizeLarge: {
        height: 55,
      },
      contained: {
        boxShadow: 'none',
        border: '1px solid #B4B6B8',
      },
      outlined: {
        boxShadow: 'none',
        border: '1px solid #B4B6B8 !important',
      },
      containedPrimary: {
        color: '#fff',
        border: '1px solid #B4B6B8',
        backgroundColor: '#0061FF',
        '&:hover': {
          color: '#FFF',
          backgroundColor: '#508BEB',
          borderColor: '#508BEB',
          boxShadow: 'unset',
        },
      },
      containedSecondary: {
        color: '#FFF',
        backgroundColor: '#D2363F',
        '&:hover': {
          color: '#FFF',
          border: '1px solid #B4B6B8',
          backgroundColor: '#D4696F',
          boxShadow: 'unset',
        },
      },
      outlinedPrimary: {
        color: '#FFF',
        border: '1px solid #B4B6B8',
        backgroundColor: 'transparent',
        '&:hover': {
          color: '#0061FF',
          borderColor: '#508BEB',
          boxShadow: 'unset',
        },
      },
    },
    MuiButtonGroup: {
      grouped: {
        flexDirection: 'column',
        width: 60,
        height: 60,
        fontSize: '0.75rem',
        '& .MuiButton-label': {
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          flexDirection: 'column',
        },
        '& .MuiButton-startIcon': {
          margin: '0 0 0.5rem',
        },
      },
      groupedOutlinedHorizontal: {
        border: '1px solid #E6E6E6 !important',
      },
    },
    MuiFab: {
      root: {
        fontSize: '.875rem',
        textTransform: 'capitalize',
        boxShadow: '0 2px 5px rgba(0,0,0,.25)',
      },
      extended: {
        '&$sizeSmall': {
          padding: defaultTheme.spacing(0, 2),
        },
      },
      sizeSmall: {
        padding: defaultTheme.spacing(0, 1.5),
      },
    },
    MuiTextField: {
      root: {
        marginBottom: defaultTheme.spacing(2),
      },
    },
    MuiOutlinedInput: {
      root: {
        borderRadius: 10,
        backgroundColor: '#FFF',
        border: '1px solid #E6E6E6',
        boxShadow: 'none',
        '&::after': {
          border: 'none',
        },
      },

      notchedOutline: {
        border: '1px solid #E6E6E6 !important',
      },
      multiline: {
        height: 'auto !important',
        '& .MuiOutlinedInput-notchedOutline': {
          border: '1px solid #E6E6E6',
        },
        '&::after': {
          border: 'none',
        },
      },
    },
    MuiFilledInput: {
      root: {
        borderBottom: '1px solid #E6E6E6',
        backgroundColor: '#FFF',
        '&:hover, &$focused': {
          backgroundColor: 'rgba(255, 255, 255, 0.9)',
        },
      },
      input: {
        padding: defaultTheme.spacing(2.5, 1.5, 1.25),
      },
      underline: {
        '&::before': {
          content: `none`,
        },
      },
    },
    MuiInputBase: {
      root: {
        color: '#6B6B6B',
        fontSize: '.875rem',
        '&$focused': {
          outline: 'unset !important',
          // border:'unset',
          boxShadow: 'unset',
          '&::after': {
            border: 'none',
          },
        },
      },
    },
    MuiFormControlLabel: {
      label: {
        marginTop: -3,
        backgroundColor: '#fff',
        marginRight: '10px',
        '&$focused': {
          borderColor: '#6C6F74 !important',
          outline: 'none',
          '&::after': {
            border: 'none',
          },
        },
      },
    },
    MuiInputLabel: {
      root: {
        backgroundColor: '#fff',
        paddingRight: '10px !important',
        color: 'red',
        '&$focused': {
          // color:'#6C6F74 !important',
          outline: 'none',
        },
        '&::after': {
          border: 'none',
        },
      },
    },
    MuiRadio: {
      colorPrimary: {
        color: '#FFF !important',
        '&$checked': {
          color: '#FFF !important',
        },
      },
      colorSecondary: {
        color: '#0061FF !important',
        '&$checked': {
          color: '#0061FF !important',
        },
      },
    },
    MuiPaper: {
      elevation2: {
        boxShadow: '0 2px 5px rgba(0,0,0,.25)',
      },
    },
    MuiAvatar: {
      root: {
        height: 30,
        width: 30,
      },
    },
    MuiSlider: {
      rail: {
        height: 4,
      },
      track: {
        height: 4,
      },
      thumb: {
        width: 28,
        height: 28,
        marginTop: '-12px',
      },
    },
  },
});

export default theme;
